import "lenis/dist/lenis.css";
import Lenis from "lenis";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

let lenisInstance = null;
let gsapTickerCallback = null;

export function initAnimStack() {
  if (lenisInstance) return lenisInstance;

  const lenis = new Lenis({
    smoothWheel: true,
    autoRaf: false,
  });

  // Keep ScrollTrigger in sync with Lenis scrolling
  lenis.on("scroll", ScrollTrigger.update);

  // Store callback so it can be removed later
  gsapTickerCallback = (time) => {
    lenis.raf(time * 1000);
  };

  // Drive Lenis from GSAP's ticker
  gsap.ticker.add(gsapTickerCallback, false, true);
  gsap.ticker.lagSmoothing(0);

  lenisInstance = lenis;

  // Refresh after everything is connected
  ScrollTrigger.refresh();

  // Custom ready event
  window.dispatchEvent(
    new CustomEvent("anim-stack:ready", {
      detail: {
        lenis,
        gsap,
        ScrollTrigger,
      },
    }),
  );

  return lenis;
}

export function destroyAnimStack() {
  if (!lenisInstance) return;

  if (gsapTickerCallback) {
    gsap.ticker.remove(gsapTickerCallback);
    gsapTickerCallback = null;
  }

  lenisInstance.destroy();
  lenisInstance = null;
}
